import styled from 'styled-components/macro';
import { Focusable, FocusableParent } from 'components/navigation';
import scaleSize from 'utils/scale-size';

export const StyledTabGroupHeader = styled.div`
  box-sizing: border-box;
  width: ${scaleSize(365)}px;
  height: ${scaleSize(60)}px;
  margin-top: -${scaleSize(20)}px;
  line-height: ${scaleSize(32)}px;
  text-align: left;
  font-family: 'RobotoRegular', sans-serif;
  font-style: normal;
  font-weight: bold;
  text-transform: uppercase;
  color: ${({ theme }) => theme.iconDefaultColor};
  opacity: 0.5;
  padding: 0 ${scaleSize(30)}px;
  font-size: ${scaleSize(20)}px;
`;

export const StyledTabPanelItem = styled(Focusable)`
  width: ${scaleSize(365)}px;
  height: ${scaleSize(80)}px;
  box-sizing: border-box;
  border-radius: ${scaleSize(12)}px 0 0 ${scaleSize(12)}px;
  line-height: ${scaleSize(80)}px;
  display: block;
  color: ${({ theme }) => theme.mainTextColor};
  text-align: left;
  padding: 0 ${scaleSize(30)}px;
  font-family: 'RobotoRegular', sans-serif;
  font-size: ${scaleSize(30)}px;
  letter-spacing: ${scaleSize(-0.21)}px;
  margin-bottom: ${scaleSize(20)}px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  &.active {
    background-color: ${({ theme }) => theme.submenuActiveColor};
  }

  &:hover {
    color: ${({ theme }) => theme.focusedTextColor};
  }

  &:focus {
    color: ${({ theme }) => theme.focusedTextColor};
    background-color: ${({ theme }) => theme.activeColor};
  }
`;

export const StyledTabPanelContent = styled.div`
  position: relative;
  width: ${scaleSize(1200)}px;
  height: ${scaleSize(1080)}px;
  margin-left: ${scaleSize(545)}px;
  white-space: nowrap;
`;

export const StyledTabPanel = styled(FocusableParent)`
  width: ${scaleSize(545)}px;
  min-height: 100%;
  height: ${({ countOfItems }) => scaleSize(countOfItems * 100 + 260)}px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.backgroundColor};
  border-right: solid 2px ${({ theme }) => theme.submenuActiveColor};
  z-index: 2;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  text-align: right;
  transform: translate3d(0, ${({ offset }) => offset}px, 0);
`;

export const StyledTabPanelTitle = styled.div`
  position: absolute;
  top: ${scaleSize(80)}px;
  font-size: ${scaleSize(68)}px;
  color: ${({ theme }) => theme.defaultColor};
  text-align: left;
  left: ${scaleSize(178)}px;
`;

export const StyledTabPanelWrapper = styled.div`
  &.tab-panel__small {
    ${StyledTabPanel} {
      width: ${scaleSize(475)}px;
    }
    ${StyledTabGroupHeader} {
      width: ${scaleSize(282)}px;
    }
    ${StyledTabPanelItem} {
      width: ${scaleSize(282)}px;
    }
    ${StyledTabPanelContent} {
      margin-left: ${scaleSize(475)}px;
      width: ${scaleSize(1445)}px;
    }
    ${StyledTabPanelTitle} {
      left: ${scaleSize(192)}px;
    }
  }
`;

export const TabPanelItemsWrapper = styled.div`
  position: absolute;
  top: ${scaleSize(260)}px;
  right: 0;
  bottom: 0;
  padding-top: ${scaleSize(20)}px;
  box-sizing: border-box;
`;

export const StyledTabGroup = styled.div`
  margin-bottom: ${scaleSize(80)}px;
`;
